import axios from "axios";

export default axios.create({
  baseURL: "https://api.quotable.io",
  params: {
    tags: "technology|famous-quotes",
  },
});
